import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatCommittmentCell, formatCustomerRateConditionCell, formatEquipmenSizeRateConditionCell, formatEquipmenTypeRateConditionCell, formatHazardousRateConditionCell, formatOrderTypeRateConditionCell, formatRateCell, formatReversibleCell, formatStatusCell, formatSteamshipLineRateConditionCell, formatUpdatedAtCell, formatValidityEnd, formatValidityStart, } from './formatters';
import { RATE_CONDITION_COLUMN_PREFIX } from 'constants/LaneRates';
export const getColumns = () => {
    const { t } = useTranslation();
    return [
        {
            accessorKey: 'rate',
            header: () => React.createElement("div", { className: "text-right" }, "Rate"),
            cell: formatRateCell,
        },
        {
            id: `${RATE_CONDITION_COLUMN_PREFIX}Customer`,
            header: () => React.createElement("div", { className: "w-36" }, t('CUSTOMER')),
            cell: formatCustomerRateConditionCell,
        },
        {
            id: `${RATE_CONDITION_COLUMN_PREFIX}EquipmentType`,
            header: () => t('EQUIPMENT'),
            cell: formatEquipmenTypeRateConditionCell,
        },
        {
            id: `${RATE_CONDITION_COLUMN_PREFIX}EquipmentSize`,
            header: () => (React.createElement("div", { className: "text-right min-w-20" }, t('EQUIP_SIZE'))),
            cell: formatEquipmenSizeRateConditionCell,
        },
        {
            id: `${RATE_CONDITION_COLUMN_PREFIX}Hazardous`,
            header: () => t('HAZARDOUS'),
            cell: formatHazardousRateConditionCell,
        },
        {
            id: `${RATE_CONDITION_COLUMN_PREFIX}OrderType`,
            header: () => React.createElement("div", { className: "min-w-20" }, t('ORDER_TYPE')),
            cell: formatOrderTypeRateConditionCell,
        },
        {
            accessorKey: `${RATE_CONDITION_COLUMN_PREFIX}SteamshipOrRailroad`,
            header: () => t('STEAMSHIP_RAILROAD'),
            cell: formatSteamshipLineRateConditionCell,
        },
        {
            accessorKey: 'reversible',
            header: () => React.createElement("div", { className: "text-right" },
                t('REVERSIBLE'),
                "?"),
            cell: formatReversibleCell,
        },
        {
            accessorKey: 'commitment',
            header: () => React.createElement("div", { className: "text-right" }, t('COMMITMENT')),
            cell: formatCommittmentCell,
        },
        {
            accessorKey: 'effectiveStart',
            header: () => (React.createElement("div", { className: "min-w-24 text-right" }, t('VALIDITY_START'))),
            cell: formatValidityStart,
        },
        {
            accessorKey: 'effectiveEnd',
            header: () => (React.createElement("div", { className: "min-w-24 text-right" }, t('VALIDITY_END'))),
            cell: formatValidityEnd,
        },
        {
            accessorKey: 'status',
            header: () => t('STATUS'),
            cell: formatStatusCell,
        },
        {
            accessorKey: 'laneRatesUpdatedAt',
            header: () => t('UPDATED'),
            cell: formatUpdatedAtCell,
        },
    ];
};
